import { useEffect, useRef, useState } from 'react';

import { useIdioma } from '../../context/IdiomaContext';

import './SelectorIdioma.css';

function SelectorIdioma() {
  const [abierto, setAbierto] = useState(false);
  const selectorRef = useRef(null);

  const { idioma, cambiarIdioma } = useIdioma();

  useEffect(() => {
    const cerrarAlPulsarFuera = (event) => {
      if (
        selectorRef.current &&
        !selectorRef.current.contains(event.target)
      ) {
        setAbierto(false);
      }
    };

    document.addEventListener(
      'mousedown',
      cerrarAlPulsarFuera
    );

    return () => {
      document.removeEventListener(
        'mousedown',
        cerrarAlPulsarFuera
      );
    };
  }, []);

  const seleccionarIdioma = (nuevoIdioma) => {
    cambiarIdioma(nuevoIdioma);
    setAbierto(false);
  };

  return (
    <div
      className="selector-idioma"
      ref={selectorRef}
    >
      <button
        type="button"
        className="selector-idioma-boton"
        onClick={() => setAbierto(!abierto)}
        aria-label="Seleccionar idioma"
        aria-expanded={abierto}
      >
        <span aria-hidden="true">🌐</span>

        <span>
          {idioma === 'es' ? 'ES' : 'EN'}
        </span>

        <span
          className={`selector-idioma-flecha ${
            abierto
              ? 'selector-idioma-flecha-abierta'
              : ''
          }`}
          aria-hidden="true"
        >
          ▾
        </span>
      </button>

      {abierto && (
        <div className="selector-idioma-menu">
          <button
            type="button"
            className={
              idioma === 'es'
                ? 'idioma-activo'
                : ''
            }
            onClick={() =>
              seleccionarIdioma('es')
            }
          >
            Español
          </button>

          <button
            type="button"
            className={
              idioma === 'en'
                ? 'idioma-activo'
                : ''
            }
            onClick={() =>
              seleccionarIdioma('en')
            }
          >
            English
          </button>
        </div>
      )}
    </div>
  );
}

export default SelectorIdioma;